// this file added by Bearer Web Developer
import { Button, CircularProgress, Menu, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from './todayDeliveries.module.scss';
import { observer } from "mobx-react-lite";
import { useAppState } from "../../../states/app-state";
import { useTodayDeliveriesMenu } from "../../../states/contexts/TodayDeliveries";
import { TReservedOrderDetails } from "../../../states/reservedOrdersState/models/reservedOrderDetails";
import { fetchDownloadUrl } from "../../../api/bearer-api";
import setReservedOrder from "../../../states/reservedOrdersState/setReservedOrder";
import DisabledClickLoading from "../../../components/DisabledClickLoading";
import Pickup from "./pickup";
import BusinessName from "./businessName";
import Destination from "./destination";
import { ShortcutReservedOrdersPlan } from "../../../states/reservedOrdersState";
import { useThemeMode } from "../../../states/contexts/theme";
import { useMenuDrawer } from "../../../states/contexts/menuDrawer";


const TodayDeliveries: React.FC = observer(() => {

    const appState = useAppState();
    const { ReservedOrders } = appState;
    const { shortcutReservedOrdersPlan: plan, fetchReservedOrdersList } = ReservedOrders;
    const { anchorEl, closeMenu, positionMenu } = useTodayDeliveriesMenu();
    const open = Boolean(anchorEl);
    const handleClose = () => {
        if (plan === ShortcutReservedOrdersPlan.ShowAtFirstForPlanA) {
            ReservedOrders.setShortcutReservedOrdersPlan(ShortcutReservedOrdersPlan.A);
        } else if (plan === ShortcutReservedOrdersPlan.ShowAtFirstForPlanB) {
            ReservedOrders.setShortcutReservedOrdersPlan(ShortcutReservedOrdersPlan.B);
        }
        closeMenu();
    };
    const { openDrawer, setOpenDrawer } = useMenuDrawer()
    const { theme } = useThemeMode();
    const fullscreen = useMediaQuery("(max-width:834px)"); // 834px max width;
    const leftPosition = positionMenu === "left";
    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(false);
    const fetchData = async () => {
        setLoadingData(true);
        await fetchReservedOrdersList();
        setLoadingData(false);
    }
    useEffect(() => {
        if (open) fetchData();
    }, [open])
    const handleConfirm = async (order: TReservedOrderDetails) => {
        if (order) {
            setLoading(true);
            const result = await appState?.ReservedOrders.confirmReservedOrderApiIntegration(order?.transport_id);
            if (result?.code === 200) {
                const login = appState.login.loggedin;
                if ((login) || (!login && appState.orders.length <= 0)) {
                    await appState.addOrder();
                    appState.selectOrder(appState.orders.length - 1);
                    const new_transport = result?.new_transport;
                    const parcel_img_fetch_url = await fetchDownloadUrl(new_transport?.parcel_img_url);
                    setReservedOrder(appState, { ...new_transport, parcel_img_fetch_url });
                    if (openDrawer) {
                        setOpenDrawer(false);
                    }
                }
                setLoading(false);
                handleClose();
            } else {
                setLoading(false);
            }
        }
    }
    return (
        <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
                'aria-labelledby': 'basic-button',
            }}
            anchorOrigin={{
                vertical: -50 + (anchorEl?.clientHeight ?? 0),
                horizontal: 'center'
            }}
            transformOrigin={{
                vertical: fullscreen ? "center" : leftPosition ? 420 : -50,
                horizontal: fullscreen ? "center" : leftPosition ? 24 : "center"
            }}
            anchorReference={fullscreen ? "anchorPosition" : undefined}
            anchorPosition={{
                top: (window.innerHeight / 2),
                left: (window.innerWidth / 2),
            }}
            classes={{ paper: styles.paper }}
            slotProps={{
                list: { style: { paddingTop: "0px", paddingBottom: "0px" } },
                root: {
                    style: {
                        zIndex: 1299,
                    }
                }
            }}
        >
            <div className={styles.today_deliveries_part} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
                {
                    positionMenu === "top" &&
                    <div className={styles.tip_polygon_top}>
                        {
                            theme === "dark" ?
                                <img src="/tip-polygon-top-black.svg" alt="" /> :
                                <img src="/tip-polygon-top-white.svg" alt="" />
                        }
                    </div>
                }
                <section className={styles.today_deliveries}>
                    <header>
                        <h4>Today’s Deliveries</h4>
                        <Button className={styles.cancel} onClick={handleClose}>
                            {
                                theme === "dark" ?
                                    <img src="/cancel-white.svg" alt="X" width={20} height={20} /> :
                                    <img src="/cancel.png" alt="X" width={20} height={20} />
                            }
                        </Button>
                    </header>
                    {
                        !loadingData &&
                        <div className={styles.orders}>
                            <ul>
                                {
                                    ReservedOrders.todayReservedOrdersList?.map(order => (
                                        <li key={order?.transport_id}>
                                            <BusinessName order={order} />
                                            <Pickup time={order?.earliest_pickup_time} />
                                            <Destination order={order} />
                                            <div>
                                                <Button className={styles.place_order}
                                                    onClick={() => { handleConfirm(order); }}
                                                >
                                                    Place Order
                                                </Button>
                                                <Button className={styles.details}
                                                    onClick={
                                                        () => {
                                                            ReservedOrders?.setActiveManageOrder(order, true);
                                                            handleClose();
                                                        }
                                                    }
                                                >
                                                    View Details
                                                </Button>
                                            </div>
                                        </li>
                                    ))
                                }
                            </ul>
                            {loading && <DisabledClickLoading />}
                        </div>
                    }
                    {loadingData && <div className={styles.loading_data}><CircularProgress /></div>}
                </section>
            </div>
        </Menu >

    )
});
export default TodayDeliveries;